






















































































































































import Vue from "vue";
import PersonaService from "@/api/PersonaService";
import CarreraService from "@/api/CarreraService";
import AuthStore from "@/store/modules/AuthStore";
import DatePicker from "@/components/shared/DatePicker.vue";
export default Vue.extend({
  components: {
    DatePicker
  },
  props: ["dialog", "dato"],
  data() {
    return {
      showPassword: false,
      editedIndex: -1,
      editedItem: {
        nombre: "",
        apellido: ""
      } as any,
      identidadItems: [
        { text: "Cédula", value: "CED" },
        { text: "RUC", value: "RUC" },
        { text: "Pasaporte", value: "PAS" }
      ],
      ///sexoitems: ["Masculino", "Femenino"],
      sexoItems: [
        { text: "Masculino", value: "M" },
        { text: "Femenino", value: "F" }
      ],
      statusItems: [
        { text: "Activo", value: true },
        { text: "Inactivo", value: false }
      ],
      roleItems: [
        { text: "Cliente", value: "0" },
        { text: "Administrador", value: "1" },
        { text: "Editor", value: "2" },
        { text: "Visitante", value: "5" }
      ],
      carreraItems: [] as { text: string; value: number }[]
    };
  },
  mounted() {
    this.editedItem = { ...this.dato };
    const carrerasVisitanteIDs = Array.isArray(this.editedItem?.carrerasVisitanteIDs)
      ? this.editedItem.carrerasVisitanteIDs
      : this.editedItem?.usuario?.carrerasVisitanteIDs;
    if (Array.isArray(carrerasVisitanteIDs)) {
      this.$set(this.editedItem, "carrerasVisitanteIDs", carrerasVisitanteIDs);
    } else if (this.editedItem?.carreraVisitanteID) {
      this.$set(this.editedItem, "carrerasVisitanteIDs", [Number(this.editedItem.carreraVisitanteID)]);
    } else {
      this.$set(this.editedItem, "carrerasVisitanteIDs", []);
    }
    this.loadCarreras();
  },
  methods: {
    loadCarreras() {
      CarreraService.getAll()
        .then((response: any[]) => {
          this.carreraItems = (response || []).map((c: any) => ({
            value: c.id,
            text: `#${c.id} - ${c.nombre}`
          }));
        })
        .catch(() => {
          this.carreraItems = [];
        });
    },
    dialogChange(value: boolean) {
      this.$emit("dialogChange", value);
    },
    close() {
      this.dialogChange(false);
    },
    save() {
      PersonaService.update(this.editedItem)
        .then(() => {
          this.close();
          this.$emit("saved", "someValue");
          this.$swal({
            toast: true,
            position: "bottom-right",
            showConfirmButton: false,
            timer: 4000,
            icon: "success",
            title: "Persona",
            text: "Guardada exitosamente"
          });
        })
        .catch(() => {
          this.$swal({
            toast: true,
            position: "bottom-right",
            showConfirmButton: false,
            timer: 3000,
            icon: "error",
            title: "Persona",
            text: "No se pudo guardar"
          });
        });
    }
  },
  computed: {
    isAdmin(): boolean {
      return AuthStore.getRole === "1";
    },
    showCarreraVisitanteField(): boolean {
      return this.editedItem?.usuario?.role === "5";
    }
  },
  watch: {}
});
